// extracted by mini-css-extract-plugin
export default {"table-container":"PiJ6ywYDjneYUb4JKqM7","table-wrapper":"e_CR3CvXq4vfPVhYOLK5"};